import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-navy px-5 py-20 sm:py-24" data-id="element-91" data-mp="vfftwlftpyqe">
      <div className="mx-auto max-w-2xl text-center" data-id="element-92" data-mp="vh0no8ubddn7">
        <h2 className="font-display text-[1.85rem] font-black leading-tight tracking-tight text-white sm:text-[2.6rem]" data-id="element-93" data-mp="19f7fp8cl0jey">
          Pronto a portare la fisica in{' '}
          <span className="italic text-tangerine" data-id="element-94" data-mp="15fq5y2q4h03z">ogni classe?</span>
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-95" data-mp="1jb22mfnu90nj">
          Smetti di pianificare. Inizia a insegnare. Ottieni risultati.
        </p>
        <div className="mt-8" data-id="element-96" data-mp="1t2evnaldhwv5">
          <CtaButton label="Voglio FISICA PRONTA ora" data-id="element-97" data-mp="1t4r8xag6rj1v" />
        </div>
      </div>
    </section>;
}